import React from 'react';
import { Link } from 'react-router-dom';

export interface SecurityMetricCard {
  label: string;
  value: number;
  to?: string;
  title?: string;
}

export interface SecurityMetricCardsProps {
  cards: SecurityMetricCard[];
}

export function SecurityMetricCards({ cards }: SecurityMetricCardsProps): React.ReactElement {
  return (
    <div className="bo-admin-metrics" aria-label="Security metrics">
      {cards.map((card) => (
        <div key={card.label} className="bo-card bo-admin-metric-card" title={card.title}>
          <p className="bo-admin-metric-label">{card.label}</p>
          {card.to ? (
            <Link to={card.to} className="bo-admin-metric-value">
              {card.value}
            </Link>
          ) : (
            <p className="bo-admin-metric-value">{card.value}</p>
          )}
        </div>
      ))}
    </div>
  );
}
